<!-- inspired by https://js.devexpress.com/Demos/WidgetsGallery/Demo/FileManager/Overview/Vue/Light/-->
<div class="p-0 d-flex flex-column flex-grow-1 h-100" style="min-height: 300px">


    <div class="col-12 d-flex flex-column  border-bottom border-1">

      <input type="file" multiple webkitdirectory class="d-none" #directoryInput (change)="fileSelected($event)"/>
      <input type="file" multiple class="d-none" #fileInput (change)="fileSelected($event)"/>

      <nav class="navbar navbar-expand navbar-dark bg-dark">
        <div class="container-fluid">
          <div id="navbarColor02" class="collapse navbar-collapse">
            <ul class="navbar-nav me-auto">


              <li class="nav-item ">
                <span href="#" class="nav-link pointer" (click)="sidebarVisible=!sidebarVisible"
                      [class.active]="sidebarVisible">
                  <i class="fa fa-folder-tree me-1"></i>
                </span>
              </li>
              <li class="nav-item" (click)="addDirectory(currentPath.getValue())">
                <span href="#" class="nav-link pointer">
                <i class="fa fa-folder-plus me-1"></i>
              </span></li>
              <li class="nav-item" (click)="uploadFile()">
                <span href="#" class="nav-link pointer">
                <i class="fa fa-file-upload  me-1"></i>
               </span></li>


              <li class="nav-item" (click)="uploadDirectory()">
                <span href="#" class="nav-link pointer">
                <i class="fa fa-upload  me-1"></i>
               </span></li>
              <li class="nav-item">

              </li>

              <li class="nav-link">
                <ol class="breadcrumb m-0">
                  <li class="breadcrumb-item">
                    <a class="pointer" (click)="currentPath.next('/')" [class.active]="currentPath.value === '/'">
                      <i class="fa fa-home me-1"></i>
                    </a>
                  </li>
                  <ng-container *ngFor="let item of currentPath.value.split('/');let last = last">
                    <li class="breadcrumb-item" *ngIf="item !== ''">
                      <a *ngIf="!last" class="pointer"
                         (click)="openPath(currentPath.value.split('/' + item)[0] + '/' + item)">{{item}}</a>
                      <span *ngIf="last">{{item}}</span>
                    </li>
                  </ng-container>
                </ol>
              </li>
            </ul>

            <div class="d-flex" *ngIf="selectionEnabled && selected.length > 0">
              <div class="text-white me-3">
                <i class="fa fa-check-circle-o"></i>
                <ng-container *ngIf="selected.length > 1"> {{selected.length}} selected</ng-container>
                <ng-container *ngIf="selected.length === 1"> {{selected[0].name}} </ng-container>

                <button type="button" class="btn btn-sm btn-primary ms-2 my-sm-0"
                        (click)="filesSelected.emit(selected)">Select
                </button>
              </div>

            </div>

            <div class="btn-group">
              <button type="button" class="btn btn-sm btn-secondary my-2 my-sm-0"
                      (click)="reload()">
                <i class="fa fa-refresh"></i>
              </button>

              <button type="button" class="btn btn-sm btn-secondary my-2 my-sm-0"
                      *ngIf="selectionEnabled"
                      (click)="emitClose()">
                <i class="fa fa-times"></i>
              </button>

            </div>
          </div>
        </div>
      </nav>
    </div>

    <div class="col-12 d-flex flex-column bg-white flex-grow-1 " >


      <as-split direction="horizontal" [gutterSize]="10" [useTransition]="true">
        <as-split-area [size]="20" [visible]="sidebarVisible"
                       [contextMenu]="$any(backgroundContextMenu)"
                       [contextMenuValue]="currentPath.value"


        >
          <div class="h-100 d-flex flex-column">
            <ul class="ps-0 mb-0" dndDropzone (dndDrop)="onDndDrop($event,  '/')">

              <ng-container *ngFor="let subAttachment of (attachmentsByPath.value['/'])">
                <app-folder
                  *ngIf="subAttachment.type === 'directory'"
                  [attachment]="subAttachment"
                  [attachmentsByPath]="attachmentsByPath"
                  [currentDragAttachment]="currentDragAttachment"
                  (clicked)="openFolder($event.attachment)"
                  (executeContextMenu)="executeAttachmentContextMenu($event.action, $event.event)"
                  (loadPath)="loadPath($event)"
                  (dndDrop)="onDndDrop($event.$event, $event.path)"
                  (dndStart)="onDragStart($event.$event, $event.attachment)"
                  (dndEnd)="onDragEnd()"
                  (dndCanceled)="onDragCanceled()"
                  [currentPath]="currentPath"
                >
                </app-folder>

              </ng-container>


            </ul>
            <div class="h-100 w-100 flex-grow-1 d-flex"
                 [contextMenu]="$any(backgroundContextMenu)"
                 (click)="openPath('/')" dndDropzone (dndDrop)="onDndDrop($event,  '/')">
            </div>
          </div>





        </as-split-area>
        <as-split-area [size]="80" [contextMenu]="$any(backgroundContextMenu)"
                       [contextMenuValue]="currentPath.value"
                       (drop)="onFileDropped($event)" (dragover)="dragOverHandler($event)"

        >

          <div class="d-flex flex-column h-100">
            <table class="table table-sm table-striped  mb-0 border-top w-100">
              <thead>
              <tr>
                <th scope="col" class="text-center">
                  <div class="form-check" *ngIf="!limitSelectToOneFile && selectionEnabled">
                    <input [(ngModel)]="allSelected"
                           (click)="toggleSelectAll();"
                           class="form-check-input pointer" type="checkbox"
                            id="select_all">


                    <label class="form-check-label visually-hidden" for="select_all">
                      Select All Files
                    </label>
                  </div>
                </th>

                <th scope="col"></th>
                <th scope="col" class="text-start">Name</th>
                <th scope="col" class="text-end">Size</th>
                <th scope="col" class="text-end">Height</th>
                <th scope="col" class="text-end">Width</th>
                <th scope="col" class="text-end">Date Modified</th>
                <th scope="col" class="text-end">Date Created</th>
              </tr>
              </thead>
              <tbody class="overflow-x-scroll" style="max-height: 100px">
              <tr
                class="pointer"
                *ngFor="let attachment of (attachments | async );let index = index"
                [contextMenu]="fileContextMenu"
                (contextmenu)="fileContextMenu.open"
                [contextMenuValue]="attachment"

                [dndDraggable]="attachment"
                [dndEffectAllowed]="'all'"
                [dndDisableIf]="currentDragAttachment?.id === attachment.id"
                (dndStart)="onDragStart($event, attachment)"
                (dndCanceled)="onDragCanceled()"
                (dndEnd)="onDragEnd()"
                [dndAllowExternal]="false"


                (click)="onClick(attachment, index)"
                (dblclick)="onDoubleClick(attachment, $event)"


                dndDropzone
                [dndDisableDropIf]="attachment.type !== 'directory'"
                [dndDropzoneDisabledClass]="'bg-white'"
                dndDragoverClass="bg-gray-700"
                (dndDrop)="onDndDrop($event,  attachment.path + '/' +  attachment.name)"
                [class.disabled]="attachment.type === 'file' && limitToImages && !isImage(attachment)"
              >
                <td class="text-center pointer">
                  <div class="form-check" *ngIf="attachment.type === 'file' && selectionEnabled && !(limitToImages && !isImage(attachment))">
                    <input class="form-check-input pointer" id="select{{attachment.id}}" type="checkbox" value=""
                           [ngModel]="isSelected(attachment)"
                           [checked]="isSelected(attachment)"
                    >
                  </div>
                </td>

                <td class="text-start" dndDragImageRef colspan="2">


                  <i *ngIf="attachment.type === 'directory'" class="fa fa-folder me-1 "></i>
                  <i *ngIf="attachment.type === 'file' && attachment.image_height !== null"
                     class="fa fa-image me-1"></i>
                  <i *ngIf="attachment.type === 'file' && attachment.image_height === null"
                     class="fa fa-file me-1 "></i>


                  {{ attachment.name}}

                </td>

                <td class="text-end">
                  <ng-container *ngIf="attachment.size">  {{ attachment.size | filesize }}</ng-container>
                </td>
                <td class="text-end">{{ attachment.image_height}} </td>
                <td class="text-end">{{ attachment.image_width}} </td>
                <td class="text-end">{{ attachment.updated_at |dfnsParseIso| formatInTimeZone:dfnsLocale:'mediumDate'}} </td>
                <td class="text-end">{{ attachment.created_at |dfnsParseIso| formatInTimeZone:dfnsLocale: 'mediumDate'}} </td>
              </tr>
              </tbody>
            </table>
            <div class="d-flex flex-grow-1" (drop)="onFileDropped($event)"
                 (dblclick)="uploadFile()"
                 (dragover)="dragOverHandler($event)">

            </div>
          </div>


        </as-split-area>
      </as-split>
    </div>

    <div class="row d-flex flex-grow-0 g-0 p-0 m-0 border-top border-1 bg-white">
      <div class="col-6   p-3">
        {{( attachments| async)?.length| number }} Items


      </div>

      <div class="col-6 p-3">

        <ng-container *ngIf="(uploaderService.uploadSummary | async)?.files?? 0 > 0">

        Uploading: {{ (uploaderService.uploadSummary | async)?.files }} /
         {{ (uploaderService.uploadSummary | async)?.progress | number:'0.0' }}%
        </ng-container>

        <div class="position-absolute bottom-0 end-0 m-3 w-25">

          <ng-container
            *ngFor="let upload of (uploaderService.currentUploads.value | keyvalue);let index = index"
          >
            <div class="small rounded-2 p-1  border-bottom border-1 mb-1"
                 [class.bg-gray-400]="!upload.value.error"
                 [class.bg-red-100]="upload.value.error"
            >
                <span class="text-dark text-truncate d-block w-100 mt-0 pb-1 ">
                  <button type="button" class="btn-close" (click)="uploaderService.cancel(upload.value)"><i
                    class="fa fa-times"></i></button>
                  {{upload.value.file.name}} ({{upload.value.file.size | filesize}})
                </span>

              <span class="d-block p-1" *ngIf="upload.value.error">
                Error:
                <ng-container *ngIf="upload.value.errorCode === 409">
                  File with this name already exists
                </ng-container>
                <ng-container *ngIf="upload.value.errorMessage">
                  {{upload.value.errorMessage }}
                </ng-container>


                <br>
                <button type="button" class="btn btn-sm btn-secondary" (click)="uploaderService.retry(upload.value)"
                        *ngIf="upload.value.error">
                <i class="fa fa-repeat"></i> Retry
                </button>
                <button  type="button" class="btn btn-sm btn-danger" (click)="uploaderService.cancel(upload.value)"
                        *ngIf="upload.value.error">
                  <i class="fa fa-times"></i> Cancel
                </button>
              </span>


              <div class="progress"  *ngIf="!upload.value.error">

                <div role="progressbar"
                     [style.width.%]="upload.value.progress"
                     class="progress-bar"
                     [class.bg-success]="upload.value.finished"

                ></div>
              </div>
            </div>
          </ng-container>
        </div>


      </div>

    </div>

</div>

<!-- https://perfectmemory.github.io/ngx-contextmenu/?path=/story/context-menu-documentation-in-a-nutshell--page&globals=backgrounds.grid:false -->
<context-menu #fileContextMenu menuClass="">

  <ng-template contextMenuItem let-value (execute)="executeAttachmentContextMenu(ContextMenuActionEnum.RENAME, $event)">
    <i class="fa fa-edit"></i> Rename
  </ng-template>

  <ng-template contextMenuItem (execute)="executeAttachmentContextMenu(ContextMenuActionEnum.DELETE, $event)">
    <i class="fa fa-trash"></i> Delete
  </ng-template>
  <ng-template contextMenuItem [divider]="true"></ng-template>

  <ng-template contextMenuItem (execute)="executeAttachmentContextMenu(ContextMenuActionEnum.NEW_DIRECTORY, $event)">
    <i class="fa fa-folder-plus"></i> New Folder
  </ng-template>

  <ng-template contextMenuItem (execute)="executeAttachmentContextMenu(ContextMenuActionEnum.UPLOAD_FILE, $event)">
    <i class="fa fa-cloud-upload"></i> Upload File
  </ng-template>

  <ng-template contextMenuItem (execute)="executeAttachmentContextMenu(ContextMenuActionEnum.UPLOAD_DIRECTORY, $event)">
    <i class="fa fa-upload"></i> Upload Folder
  </ng-template>

  <ng-template contextMenuItem [divider]="true"></ng-template>

  <ng-template contextMenuItem (execute)="executeAttachmentContextMenu(ContextMenuActionEnum.RELOAD, $event)">
    <i class="fa fa-refresh"></i> Refresh
  </ng-template>
</context-menu>


<context-menu #backgroundContextMenu>
  <ng-template contextMenuItem (execute)="executePathContextMenu(ContextMenuActionEnum.NEW_DIRECTORY, $event)">
    <i class="fa fa-folder-plus"></i> New Directory
  </ng-template>

  <ng-template contextMenuItem (execute)="executePathContextMenu(ContextMenuActionEnum.UPLOAD_FILE, $event)">
    <i class="fa fa-cloud-upload"></i> Upload File
  </ng-template>


  <ng-template contextMenuItem (execute)="executePathContextMenu(ContextMenuActionEnum.UPLOAD_DIRECTORY, $event)">
    <i class="fa fa-upload"></i> Upload Folder
  </ng-template>

  <ng-template contextMenuItem [divider]="true"></ng-template>

  <ng-template contextMenuItem (execute)="executePathContextMenu(ContextMenuActionEnum.RELOAD, $event)">
    <i class="fa fa-refresh"></i> Refresh
  </ng-template>
</context-menu>


<ng-template #newDirectoryModalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">New Directory</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="newDirectoryModal?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <form (submit)="storeDirectory()">
      <app-form-group
        [name]="'name'"
        [autofocus]="true"
        [formControl]="newDirectoryForm.controls.name">
      </app-form-group>

    </form>
  </div>
  <div class="modal-footer">

    <button  type="button" class="btn btn-outline-danger" (click)="newDirectoryModal?.hide()">Cancel</button>
    <button  type="button" class="btn btn-primary" (click)="storeDirectory()">Save</button>
  </div>
</ng-template>


<ng-template #renameAttachmentModalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Rename</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="renameAttachmentModal?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <form (submit)="renameAttachment()" [formGroup]=renameAttachmentForm>
      <app-form-group
        [autofocus]="true"
        [name]="'name'"
        [formControl]="renameAttachmentForm.controls.name">
      </app-form-group>

    </form>
  </div>
  <div class="modal-footer">

    <button  type="button" class="btn btn-outline-danger" (click)="renameAttachmentModal?.hide()">Cancel</button>
    <button  type="button" class="btn btn-primary" (click)="renameAttachment()">Save</button>
  </div>
</ng-template>



<ng-template #previewAttachmentModalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ previewAttachment?.name}}</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="previewAttachmentModal?.hide()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>

  </div>
  <div class="modal-body" *ngIf="previewAttachment">
    <p class="small muted" >
      <ng-container *ngIf="previewAttachment.image_width && previewAttachment.image_height">
        Height: {{previewAttachment.image_height|number}}px <br>
        Width: {{previewAttachment.image_width|number}}px <br>
      </ng-container>

      Size: {{(previewAttachment.size?? 0) | filesize}} <br>
    </p>
    <label class="form-label" for="numeric_id">URL</label>
    <div class="input-group cursor-copy "
         ngxClipboard
         [cbContent]="previewAttachment.url ?? ''"
         tooltip="{{'shared.components.copied_tooltip' | translate}}"
         placement="top"
         triggers=""
         (mouseleave)="tooltip.hide()"
         #tooltip="bs-tooltip"
         (cbOnSuccess)="tooltip.show();">

          <span id="numeric_id"  class="form-control disabled mono bg-light text-truncate"
                    >{{previewAttachment.url}}</span>
      <button type="button" class="input-group-text cursor-copy " >
        <i class="fa fa-copy"></i>
      </button>


    </div>

    <img [alt]="previewAttachment.name" *ngIf="previewAttachment.image_width && previewAttachment.image_height" [src]="previewAttachment.url" class="mt-3 w-100">


    <button type="button" class="btn btn-primary mt-2 " (click)="openInNewTab(previewAttachment.url)" *ngIf="!previewAttachment.image_width || !previewAttachment.image_height">
      <i class="fa fa-download"></i> Download
    </button>

  </div>
  <div class="modal-footer">

    <button  type="button" class="btn btn-secondary"  *ngIf="previewAttachment && selectionEnabled"  (click)="filesSelected.next([previewAttachment])">Select</button>
    <button  type="button" class="btn btn-primary"  (click)="previewAttachmentModal?.hide()">Close</button>
  </div>
</ng-template>
